import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

const defaultEl = {
  id: null,
  type: '',
  year: '',
  month: '',
  day: '',
  description: ''
};

export default {
  name: 'HolidayEdit',
  data () {
    return {
      editEl: defaultEl,
      isLoading: false
    }
  },
  validations: {
    editEl: {
      type: { required },
      year: { },
      month: { },
      day: { required },
      description: { }
    }
  },
  props: {
    editPerm: {
      type: String,
      default: 'edit-holidays'
    },
    basePath: {
      type: String,
      default: ''
    },
    isModal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    typeOptions () {
      const types = [
        { value: 'holiday', text: this.$t('holidays.type.options.holiday') },
        { value: 'celebration', text: this.$t('holidays.type.options.celebration') },
        { value: 'workday', text: this.$t('holidays.type.options.workday') },
        { value: 'day_off', text: this.$t('holidays.type.options.day_off') },
        { value: 'internal', text: this.$t('holidays.type.options.internal') }
      ];
      return types;
    },
    baseTransParam () {
      return 'holidays';
    },
    getTitle () {
      if (this.editEl.id) {
        return this.$t(`${this.baseTransParam}.actions.edit`);
      }
      return this.$t(`${this.baseTransParam}.actions.new`);
    },
    canEdit () {
      return !this.isLoading;
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.v$.$reset();
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        this.isLoading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        this.ApiRequest.request(this.basePath + '/save' + (reqData.id ? '/' + reqData.id : ''), this.ApiRequest.REQUEST_POST, reqData, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.$store.dispatch('reloadConfig');
            this.$emit('saved', response.data);
            this.close();
          }
          this.isLoading = false;
        });
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
